import React from "react";

import { FormFeedback, Label } from "reactstrap";
import Radio from "./Radio";
import RequiredIndicator from "../Form/RequiredIndicator";

const BooleanRadio = (props) => {
	const {
		error,
		falseLabel,
		label,
		name,
		required,
		setFieldValue,
		touched,
		trueLabel,
		value
	} = props;

	const handleChange = (e) => {
		setFieldValue(name, e.target.value === "true" ? true : false);
	};

	const invalid = required && touched && error ? true : false;
	const valid = required && touched && !error ? true : false;

	const styles = {
		display: invalid ? "block" : "none"
	};

	return (
		<React.Fragment>
			<Label>
				{label} {required && <RequiredIndicator />}
			</Label>
			<Radio
				name={name}
				label={trueLabel}
				radioValue="true"
				onChange={handleChange}
				checked={value === true}
				invalid={invalid}
				valid={valid}
			/>
			<Radio
				name={name}
				label={falseLabel}
				radioValue="false"
				onChange={handleChange}
				checked={value === false}
				value={value}
				invalid={invalid}
				valid={valid}
			/>
			<FormFeedback valid={valid} style={styles}>
				{error}
			</FormFeedback>
		</React.Fragment>
	);
};

BooleanRadio.defaultProps = {
	trueLabel: "Yes",
	falseLabel: "No"
};

export default BooleanRadio;
